import { atom } from 'jotai';

export const itemFilterAtom = atom<string[]>([]);

export const itemColumnsAtom = atom(2);
